import React, { useEffect, useState } from "react";
import FleetLocation from "./widgets/fleetLocation/FleetLocation";
import FleetLocationMap from "./widgets/fleetLocation/FleetLocationMap";
import OverviewStatsPanel from "./OverviewStatsPanel";
import { fetchFleetLocationMarkers } from "./widgets/fleetLocation/fleetLocationData";

/**
 * Overview tab content: left = Fleet locations table, right = Stats + Map.
 */
const OverviewCard = ({
  fleetSummary,
  isLoadingFleet,
  fleetError,
  usernames = [],
  userIds = [],
  userIdToUsername = {},
  hasResolvedUserIds = false,
  programName,
  lastAssessmentCreatedAtByUsername,
  evCountByUsernameDomicile,
  cityNameByUsername,
}) => {
  const [fleetLocationFilterText, setFleetLocationFilterText] = useState("");
  const [markers, setMarkers] = useState([]);
  const [isLoadingMarkers, setIsLoadingMarkers] = useState(true);
  const [markersError, setMarkersError] = useState(null);

  useEffect(() => {
    if (!hasResolvedUserIds) {
      setIsLoadingMarkers(true);
      return;
    }

    let cancelled = false;

    const loadMarkers = async () => {
      setIsLoadingMarkers(true);
      setMarkersError(null);
      try {
        const nextMarkers = await fetchFleetLocationMarkers(
          userIds,
          userIdToUsername,
        );
        if (!cancelled) {
          setMarkers(nextMarkers);
        }
      } catch (err) {
        if (cancelled) return;
        console.error("Failed to load fleet location markers:", err);
        setMarkers([]);
        setMarkersError(err?.message || "Failed to load fleet locations.");
      } finally {
        if (!cancelled) {
          setIsLoadingMarkers(false);
        }
      }
    };

    loadMarkers();
    return () => {
      cancelled = true;
    };
  }, [hasResolvedUserIds, userIds, userIdToUsername]);

  return (
    <div className="flex w-full gap-4">
      {/* Left: Fleet locations table */}
      <div className="w-2/3 flex flex-col gap-4 rounded-xl border border-gray-100 bg-white p-4 shadow-sm">
        <FleetLocation
          markers={markers}
          isLoadingMarkers={isLoadingMarkers}
          markersError={markersError}
          usernames={usernames}
          programName={programName}
          lastAssessmentCreatedAtByUsername={
            lastAssessmentCreatedAtByUsername
          }
          evCountByUsernameDomicile={evCountByUsernameDomicile}
          cityNameByUsername={cityNameByUsername}
          filterText={fleetLocationFilterText}
          onFilterTextChange={setFleetLocationFilterText}
        />
      </div>

      {/* Right: Overview stats + map */}
      <div className="w-1/3 flex flex-col gap-4">
        <OverviewStatsPanel
          fleetSummary={fleetSummary}
          isLoadingFleet={isLoadingFleet}
          fleetError={fleetError}
        />
        <FleetLocationMap
          markers={markers}
          isLoadingMarkers={isLoadingMarkers}
          markersError={markersError}
          usernames={usernames}
          filterText={fleetLocationFilterText}
          height="400px"
        />
      </div>
    </div>
  );
};

export default OverviewCard;
